// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__ToVPu","heading":"Loader_heading__5SJgH","loader":"Loader_loader__gPW3M","spin":"Loader_spin__7C1L1","inner-spin":"Loader_inner-spin__7iC0M"};